import React from "react";
import point from "./../../../Images/point.png";

const HairDetoxSpaMaintain = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>Maintenance Tips for Detoxed Hair</h5>
      <p>
        The Hair Hydration Boost Spa experience at SCENT offers numerous
        benefits, transforming hair from the inside out. Here are some of the
        reasons why clients return to us for their moisture needs:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Use Gentle, Sulfate-Free Shampoos{" "}
          </span>
          <p>
            Sulfate-free shampoos are gentle on your hair and scalp, preventing
            excessive dryness and maintaining the effects of the detox.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Avoid Overusing Styling Products{" "}
          </span>
          <p>
            Try to limit the use of heavy styling products that can cause
            buildup. Opt for lighter, natural alternatives when possible.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Reduced Breakage and Split Ends:{" "}
          </span>
          <p>
            Properly moisturized hair is more resilient, meaning less breakage
            and fewer split ends. This helps you maintain length and fullness,
            which is especially important for those growing their hair out.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Regularly Brush Your Hair{" "}
          </span>
          <p>
            Brushing helps distribute natural oils and keeps your scalp healthy
            by stimulating circulation.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Protect Hair from Environmental Stressors{" "}
          </span>
          <p>
            Pollution and sun exposure can harm your hair. Use a hat or scarf to
            shield your hair from direct sunlight and environmental pollutants.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Schedule Routine Detox Spa Treatments{" "}
          </span>
          <p>
            To keep your hair healthy and buildup-free, consider visiting
            SCENT’s Hair Detox Spa in Bangalore every few months.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default HairDetoxSpaMaintain;
